import {Tabs} from '@wandb/components';
import React, {type ReactNode} from 'react';

import {BaselineSettings} from './baseline/BaselineSettings';
import {SettingsContentWrapper} from './components/SettingsContentWrapper';
import {WORKSPACE_RUN_DISPLAY_SETTINGS_DESCRIPTION} from './constants';
import {SemanticLegendColorTabWithCategoricalConfig} from './semanticLegend/SemanticLegendColorTabWithCategoricalConfig';

const TAB_ITEMS = [
  {
    id: 'baseline',
    label: 'Baseline',
    content: <BaselineSettings />,
  },
  {
    id: 'colors',
    label: 'Colors',
    content: <SemanticLegendColorTabWithCategoricalConfig />,
  },
];

type RunSettingsProps = {
  contentHeader?: ReactNode;
};
export function RunsSettings({contentHeader}: RunSettingsProps) {
  return (
    <SettingsContentWrapper
      header={contentHeader}
      title="Runs"
      description={WORKSPACE_RUN_DISPLAY_SETTINGS_DESCRIPTION}>
      <Tabs aria-label="Runs settings" items={TAB_ITEMS} />
    </SettingsContentWrapper>
  );
}
